import React from 'react';

interface StatusIndicatorProps {
  status: boolean;
  trueLabel?: string;
  falseLabel?: string;
  color?: 'green' | 'orange' | 'red';
}

interface MultiStatusIndicatorProps {
  value: number;
  thresholds: {
    value: number;
    label: string;
    color: 'green' | 'orange' | 'red';
  }[];
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ 
  status, 
  trueLabel = "Yes", 
  falseLabel = "No",
  color
}) => {
  const getColorClass = () => {
    if (color) {
      switch (color) {
        case 'green': return 'bg-green-500';
        case 'orange': return 'bg-orange-500';
        case 'red': return 'bg-red-500';
      }
    }
    return status ? 'bg-green-500' : 'bg-red-500';
  };

  return (
    <div className="flex items-center gap-2">
      <div 
        className={`w-3 h-3 rounded-full ${getColorClass()}`}
      />
      <span className="text-sm font-semibold">
        {status ? trueLabel : falseLabel}
      </span>
    </div>
  );
};

export const MultiStatusIndicator: React.FC<MultiStatusIndicatorProps> = ({ 
  value, 
  thresholds 
}) => {
  // Sort thresholds in descending order
  const sortedThresholds = [...thresholds].sort((a, b) => b.value - a.value);
  
  // Find the appropriate threshold
  const status = sortedThresholds.find(threshold => value > threshold.value) || 
    sortedThresholds[sortedThresholds.length - 1];

  const getColorClass = () => {
    switch (status.color) {
      case 'green': return 'bg-green-500';
      case 'orange': return 'bg-orange-500';
      case 'red': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div className="flex items-center gap-2">
      <div 
        className={`w-3 h-3 rounded-full ${getColorClass()}`}
      />
      <span className="text-sm font-semibold">
        {status.label}
      </span>
    </div>
  );
};